export default "__VITE_ASSET__Zg62SX_K__"